/* eslint-disable max-len */
import { HealthSurveillanceQuestionConfig, MedicalTypeIds } from "../models";

import * as questionIds from "./questionIds";

const section7MedicalTypes = [
    MedicalTypeIds.SkinFaceToFace,
    MedicalTypeIds.LAAWorker,
    MedicalTypeIds.SkinFaceToFaceLevel1,
    MedicalTypeIds.SkinAssessmentLevel2
];

/**
 * @deprecated Prefer sections exported from `import { sections } from "../questionnaire";` which is in a data structure suitable for use with custom medicals
 */
export const section7Questions: HealthSurveillanceQuestionConfig[] = [
    {
        id: questionIds.PaintsAndThinners,
        questionText: "Paints and thinners",
        medicalTypes: section7MedicalTypes
    },
    {
        id: questionIds.LubeOilsGreases,
        questionText: "Lube oils and greases",
        medicalTypes: section7MedicalTypes
    },
    {
        id: questionIds.AdhedivesGlues,
        questionText: "Adhesives and glues",
        medicalTypes: section7MedicalTypes
    },
    {
        id: questionIds.GrindingAbrasives,
        questionText: "Grinding abrasives",
        medicalTypes: section7MedicalTypes
    },
    {
        id: questionIds.Solvents,
        questionText: "Solvents",
        medicalTypes: section7MedicalTypes
    },
    {
        id: questionIds.RegularHandWashing,
        questionText: "Regular Hand Washing",
        medicalTypes: section7MedicalTypes
    },
    {
        id: questionIds.LaboratoryChemicals,
        questionText: "Laboratory chemicals",
        medicalTypes: section7MedicalTypes
    },
    {
        id: questionIds.CleaningMaterials,
        questionText: "Cleaning materials",
        medicalTypes: section7MedicalTypes
    },
    {
        id: questionIds.OrganicChemicals,
        questionText: "Organic chemicals",
        medicalTypes: section7MedicalTypes
    },
    {
        id: questionIds.EpoxyResins,
        questionText: "Epoxy resins",
        medicalTypes: section7MedicalTypes
    },
    {
        id: questionIds.Latex,
        questionText: "Latex",
        medicalTypes: section7MedicalTypes
    },
    {
        id: questionIds.StrongAcidsAlkalis,
        questionText: "Strong acids and alkalis",
        medicalTypes: section7MedicalTypes
    },
    {
        id: questionIds.SkinSymptomsDetails,
        questionText: "If applicable please detail when did the symptoms begin and where do they affect you?",
        medicalTypes: section7MedicalTypes
    },
    {
        id: questionIds.HasJobCausedWorsedSkinCondition,
        questionText: "Do you think that your job has caused or worsened any skin condition you have had?",
        medicalTypes: section7MedicalTypes
    },
    {
        id: questionIds.HasJobCausedWorsedSkinConditionFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section7MedicalTypes
    },
    {
        id: questionIds.HadTreatmentForSkinCondition,
        questionText: "Have you had any treatment for a skin condition?",
        medicalTypes: section7MedicalTypes
    },
    {
        id: questionIds.HadTreatmentForSkinConditionFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section7MedicalTypes
    },
    {
        id: questionIds.SeenDoctorSkinProblem,
        questionText: "Have you ever seen a doctor (GP, Consultant, OHP) about a skin problem?",
        medicalTypes: section7MedicalTypes
    },
    {
        id: questionIds.SeenDoctorSkinProblemFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: section7MedicalTypes
    }
];
/* eslint-enable max-len */

export const ChemicalUsageOptions = [
    { text: "Daily", value: "Daily" },
    { text: "Weekly", value: "Weekly" },
    { text: "Rarely", value: "Rarely" },
    { text: "Never", value: "Never" }
];
